import { isAudioDeviceAvailable, isVideoDeviceAvailable } from "./device";

export const FRAME_RATE = 24;
export const VIDEO_WIDTH = 1280;
export const VIDEO_HEIGHT = 720;

export function getMediaStreamConstraints(constraints: MediaStreamConstraints) {
  const newConstraints = { ...constraints };

  if (typeof constraints.video === "object") {
    newConstraints.video = {
      ...constraints.video,
      width: VIDEO_WIDTH,
      height: VIDEO_HEIGHT,
      frameRate: FRAME_RATE,
    };
  }

  return newConstraints;
}

export interface GetContraintsOptions {
  audioDeviceId?: string;
  videoDeviceId?: string;
  type?: "ideal" | "exact";
  devices: MediaDeviceInfo[];
}

export function getContraints({
  type = "ideal",
  audioDeviceId,
  videoDeviceId,
  devices,
}: GetContraintsOptions): MediaStreamConstraints {
  const useDefaultAudio =
    typeof audioDeviceId !== "undefined" &&
    !isAudioDeviceAvailable(audioDeviceId, devices);
  const useDefaultVideo =
    typeof videoDeviceId !== "undefined" &&
    !isVideoDeviceAvailable(videoDeviceId, devices);

  const constraints: MediaStreamConstraints = getMediaStreamConstraints({
    audio: useDefaultAudio
      ? { deviceId: "" }
      : { deviceId: { [type]: audioDeviceId } },
    video: useDefaultVideo
      ? { deviceId: "" }
      : { deviceId: { [type]: videoDeviceId } },
  });

  // Check if the browser is a mobile browser or Safari
  const isMobileBrowser =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isMobileBrowser || isSafari) {
    // For mobile browsers and Safari, we need to add 'facingMode' to constraints.video if it's an object.
    // This is a relay call - the user has to be on screen, so always the front camera.
    if (constraints.video && typeof constraints.video === "object") {
      constraints.video.facingMode = "user";
    }
  }

  if (typeof audioDeviceId === "undefined") {
    delete constraints.audio;
  }
  if (typeof videoDeviceId === "undefined") {
    delete constraints.video;
  }

  return constraints;
}
